import script from "./CataloguePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./CataloguePreview.vue?vue&type=script&setup=true&lang=js"

export default script